/* 🤖 this file was generated by svg-to-ts*/
export const icoGit: {
  name: 'git';
  data: string;
} = {
  name: 'git',
  data: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21.62 11.11L12.889 2.38a1.291 1.291 0 00-1.823 0L9.257 4.191l2.299 2.3a1.531 1.531 0 011.939 1.95l2.214 2.218a1.53 1.53 0 011.583 2.532c-.599.6-1.566.6-2.166 0a1.537 1.537 0 01-.337-1.662l-2.074-2.064v5.438c.146.072.286.17.407.29a1.538 1.538 0 010 2.167 1.536 1.536 0 01-2.174 0 1.528 1.528 0 010-2.164 1.57 1.57 0 01.504-.34V9.366a1.53 1.53 0 01-.83-2.009l-2.26-2.271-5.987 5.983c-.5.505-.5 1.32 0 1.825l8.731 8.731a1.285 1.285 0 001.821 0l8.69-8.691a1.285 1.285 0 00.003-1.823z" fill="#909090"/></svg>`
};
